<template>
  <div :style="{ zIndex: zIndex }">
    <div
      :class="{ 'bottom-shadow': isSticky }"
      :style="stickyStyle"
    >
      <slot>
        <div>sticky</div>
      </slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Sticky',
  props: {
    stickyTop: {
      type: Number,
      default: 40,
    },
    zIndex: {
      type: Number,
      default: 1010,
    },
  },
  data() {
    return {
      active: false,
      position: '',
      width: undefined,
      isSticky: false,
    }
  },
  computed: {
    ...mapGetters({
      isSideBarOpen: 'app/isSideBarOpen',
    }),
    height() {
      return this.isSticky ? `${this.$el.getBoundingClientRect().height}px` : 'auto';
    },
    stickyStyle() {
      return {
        top: `${this.stickyTop}px`,
        zIndex: this.zIndex,
        position: this.position,
        width: this.width,
        height: `${this.height}px`,
      }
    },
  },
  watch: {
    isSideBarOpen() {
      // force to trigger resize handler when side bar is triggered.
      setTimeout(() => {
        this.handleResize()
      }, 200)
    },
    isSticky(value) {
      this.$emit('stickinessChanged', {
        isSticky: value,
        height: this.height,
      })
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
    this.handleResize() // init proper styles
  },
  activated() {
    this.handleScroll()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    sticky() {
      if (this.active) {
        return
      }
      this.position = 'fixed'
      this.active = true
      this.width = `${this.width}px`
      this.isSticky = true
    },
    reset() {
      if (!this.active) {
        return
      }
      this.position = ''
      this.width = 'auto'
      this.active = false
      this.isSticky = false
    },
    handleScroll() {
      this.width = `${this.$el.getBoundingClientRect().width}px`
      const offsetTop = this.$el.getBoundingClientRect().top
      if (offsetTop < this.stickyTop) {
        this.sticky()
        return
      }
      this.reset()
    },
    handleResize() {
      this.width = `${this.$el.getBoundingClientRect().width}px`
    },
  },
}
</script>

<style lang="scss" scoped>
.bottom-shadow {
  box-shadow: 0 4px 2px -2px rgba(0,0,0,.1);
}
</style>
